import type { Variants } from 'framer-motion';

export const animationConfig = {
  // Duration constants for consistent, snappy animations
  duration: {
    instant: 0.1,
    fast: 0.15,
    normal: 0.2,
    slow: 0.25,
  },

  // Easing functions
  easing: {
    smooth: [0.4, 0, 0.2, 1] as [number, number, number, number],
    bounce: [0.68, -0.55, 0.265, 1.55] as [number, number, number, number],
    sharp: [0.4, 0, 0.6, 1] as [number, number, number, number],
  },

  // Spring configurations for Framer Motion
  spring: {
    snappy: { type: "spring" as const, stiffness: 300, damping: 30 },
    smooth: { type: "spring" as const, stiffness: 200, damping: 25 },
    bouncy: { type: "spring" as const, stiffness: 400, damping: 20 },
  },

  // Stagger delays
  stagger: {
    fast: 0.03,
    normal: 0.05,
    slow: 0.08,
  },
}

// Check for reduced motion preference
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

// Animation variants with reduced motion support
export const createAnimationVariants = (variants: Variants, reducedVariants?: Variants): Variants => {
  if (prefersReducedMotion() && reducedVariants) {
    return reducedVariants
  }
  return variants
}

// Optimized fade animations
export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 10,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: animationConfig.duration.fast }
  }
}

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: animationConfig.duration.fast }
  }
}

// Container animations with optimized stagger
export const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: animationConfig.duration.instant,
      staggerChildren: animationConfig.stagger.fast,
    }
  }
}

// Reduced motion variants
export const reducedMotionVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0 }
  }
}
